import React from "react";
import './style.css';
import Grid from '@material-ui/core/Grid';
//import { AiOutlineSearch } from "react-icons/ai";
//import { Collapse } from "react-collapse";
//import { NavLink } from 'react-router-dom';
import SideNav from './../../../components/SideNav_OG';
import Logout from './../../../components/Button_Logout';

export default function Tela_OG() {
  //let [search, setSearch] = useState(false);
  return(
    <>
        <SideNav />
        <div id="top_OG">

          <div id="backbutton">
              <Logout />
          </div>

        </div>
        
      <Grid>
          <div id= "divOG">
            <a id="aOG" href="/Tela_Consultas"> <button id="og-button">Pedidos de Consultas</button></a>
            <a id="aOG" href="/Tela_Pedidos_de_Inscricao"><button id="og-button">Pedidos de Inscrição</button></a>
            <a id="aOG" href="/Tela_Cadastros"><button id="og-button">Dados de Cadastros</button></a>          
          </div>
        </Grid>

    </>
  );
}